type BadgeStatusProps = {
  title: string;
  color?: "green" | "yellow" | "red" | "purple" | "gray" | "blue";
};

export const BadgeStatus = (props: BadgeStatusProps) => {
  return (
    <div
      className={`px-3 md:px-4 py-1 md:py-1.5 flex items-center justify-center rounded-full text-white text-sm w-fit ${
        props.color === "purple"
          ? "bg-purple-200 border-purple-400 border"
          : props.color === "green"
          ? "bg-green-200 border-green-400 border"
          : props.color === "yellow"
          ? "bg-yellow-200 border-yellow-400 border"
          : props.color === "red"
          ? "bg-red-200 border-red-400 border"
          : props.color === "blue"
          ? "bg-blue-200 border-blue-400 border"
          : props.color === "gray"
          ? "bg-gray-200 border-gray-400 border"
          : "bg-gray-200 border-gray-400 border"
      }`}
    >
      <span
        className={`text-[10px] md:text-xs font-bold ${
          props.color === "purple"
            ? "text-purple-800"
            : props.color === "green"
            ? "text-green-700"
            : props.color === "yellow"
            ? "text-yellow-700"
            : props.color === "red"
            ? "text-red-700"
            : props.color === "blue"
            ? "text-blue-700"
            : props.color === "gray"
            ? "text-gray-800"
            : "text-gray-800"
        }`}
      >
        {props.title}
      </span>
    </div>
  );
};
